import { useListInternalOrderContactsQuery } from '../../../../../../../API/order/contacts/InternalContactsApi';
import { useMemo } from 'react';
import { UUID } from '../../../../../../../types/shared/UUID';
import { useParams } from 'react-router-dom';

const closerRoleName = 'closer';

export const useGetCloser = () => {
  const { orderId } = useParams<{ orderId: UUID }>();
  const { data: internalContacts = [], error, isLoading, isSuccess } = useListInternalOrderContactsQuery(orderId);

  const assignedCloser = useMemo(() => {
    return internalContacts.find((contact) => contact.roles.includes(closerRoleName));
  }, [internalContacts]);
  return { assignedCloser, error, isLoading, isSuccess };
};
